import React, { useRef, useEffect, useState } from "react";
import "./Standeefeature.scss";
import Offlinecontact from "../../Images/OfflineSharing.png";
import scanpay from "../../Images/Scan-pay.png";
import Soundbox from "../../Images/Soundbox.png";
import Wallet from "../../Images/Wallet.png";
import OneTap from "../../Images/One-tap.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { faCentSign } from "@fortawesome/free-solid-svg-icons";
import NextButton from "../../Images/NextButton.svg";
import PrevButton from "../../Images/PrevButton.svg";
const StandeeFeatures = () => {
  let innerWidth = window.innerWidth;
  const [divToShow, setDivToShow] = useState(3.5);
  useEffect(() => {
    if (innerWidth < 1025) {
      setDivToShow(3.25);
    }
    if (innerWidth < 851) {
      setDivToShow(2.25);
    }
    if (innerWidth < 500) {
      setDivToShow(1.25);
    }
  }, [innerWidth]);
  const data = [
    {
      id: 1,
      img: Soundbox,
      title: "Soundbox",
      description: "feature for payment announcement",
    },
    {
      id: 2,
      img: scanpay,
      title: "Scan & pay",
      description: "easily via QR code.",
    },
    {
      id: 3,
      img: Offlinecontact,
      title: "Offline contact sharing",
      description: "for quick connections",
    },
    {
      id: 4,
      img: OneTap,
      title: "One-tap data sharing ",
      description: "via NFC-enabled cards",
    },
    {
      id: 5,
      img: Wallet,
      title: "Store Apple/Google Wallet ",
      description: "Details Instantly",
    },

   
  ];
  const settings = {
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    // slidesToShow: 3.5,
    slidesToShow: divToShow,
    slidesToScroll: 1,
    nextArrow: <img src={NextButton} alt="Next" />,
    prevArrow: <img src={PrevButton} alt="Prev" />,
    // responsive: [
    //   {
    //     breakpoint: 1300,
    //     settings: {
    //       slidesToShow: 3.5,
    //       slidesToScroll: 1,
    //     },
    //   },
    //   {
    //     breakpoint: 1100,
    //     settings: {
    //       slidesToShow: 3.5,
    //       slidesToScroll: 1,
    //     },
    //   },
    //   {
    //     breakpoint: 900,
    //     settings: {
    //       slidesToShow: 2,
    //       slidesToScroll: 1,
    //     },
    //   },
    //   {
    //     breakpoint: 600,
    //     settings: {
    //       slidesToShow: 2,
    //       slidesToScroll: 1,
    //       autoplay: true,
    //     },
    //   },
    //   {
    //     breakpoint: 500,
    //     settings: {
    //       infinite: true,
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //     },
    //   },
    // ],
  };
  const handleClick=()=>{
    document.getElementById("enquiryformprd").scrollIntoView({ behavior: "smooth" });
  }
  return (
    <div className="StandeeOuter" id="standeess">
      {/* <div className='Standee container'> */}
      <div className="Standee">
        <div className="standee-features-wrapper">
          <div className="">
            <h2>Served Fast, Get Paid Faster With Our Payment Standee</h2>
            <p>
              Get seamless payments from your customers via BusinessBay’s
              Payment standee:
            </p>
          </div>
          <div>
            <button onClick={()=>handleClick()}>Get Your Standee</button>
          </div>
        </div>
        <div className="StandeeinnerWrapper">
          <div className="Standee_inner">
            <Slider {...settings}>
              {data.map((item) => (
                <div className="StandeeWrapper" key={item.id}>
                  <div className="StandeeBox">
                    <div className="imgBox">
                      <img
                        src={item.img}
                        alt=""
                        //    style={{height:"300px", width:"300px"}}
                      />
                    </div>
                    <div className="headingparawrapper">
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StandeeFeatures;

// import React from "react";
// import "./Standeefeature.css";
// export const StandeeFeatures = () => {
//   return (
//     <div className="">
//       <div className="standee-features-wrapper">
//         <div className="">
//           <h2>Served Fast, Get Paid Faster With Our Payment Standee</h2>
//           <p>
//             Get seamless payments from your customers via BusinessBay’s Payment
//             standee:
//           </p>
//         </div>
//         <div>
//           <button>Get Your Standee</button>
//         </div>
//       </div>
//     </div>
//   );
// };
